const FLOORPLAN_MEASURES = {
  A: {
    "LIVING / DINING / KITCHEN": [`5.0m x 5.6m`, `16’5” x 18’4”`],
    "BEDROOM 1": [`2.8m x 4.7m`, `9’2” x 15’5”`],
    "BEDROOM 2": [`3.2m x 3.8m`, `10’6” x 12’6”`],
    BALCONY: [`4.0m x 2.4m`, `13’1” x 7’10”`],
    "TOTAL INTERNAL AREA": [`82 SQ M 882 SQ FT`],
    "TOTAL EXTERNAL AREA": [`8 SQ M 86 SQ FT`],
  },
  B: {
    "LIVING / DINING / KITCHEN": [`4.4m x 5.8m`, `14’5” x 19’0”`],
    "BEDROOM 1": [`5.1m x 2.8m`, `16’9” x 9’2”`],
    "BEDROOM 2": [`3.8m x 3.1m`, `12’6” x 10’2”`],
    BALCONY: [`3.9m x 2.1m`, `12’10” x 6’11”`],
    "TOTAL INTERNAL AREA": [`72 SQ M 775 SQ FT`],
    "TOTAL EXTERNAL AREA": [`7 SQ M 75 SQ FT`],
  },
  C: {
    "LIVING / DINING / KITCHEN": [`4.4m x 5.8m`, `14’5” x 19’0”`],
    "BEDROOM 1": [`5.1m x 2.8m`, `16’9” x 9’2”`],
    "BEDROOM 2": [`3.8m x 3.1m`, `12’6” x 10’2”`],
    BALCONY: [`3.9m x 2.1m`, `12’10” x 6’11”`],
    "TOTAL INTERNAL AREA": [`72 SQ M 775 SQ FT`],
    "TOTAL EXTERNAL AREA": [`7 SQ M 75 SQ FT`],
  },
  D: {
    "LIVING / DINING": [`3.0m x 3.6m`, `9’10” x 11’10”`],
    KITCHEN: [`1.9m x 2.0m`, `6’3” x 6’7”`],
    BEDROOM: [`1 3.1m x 3.6m`, `10’2” x 11’10”`],
    BALCONY: [`2.3m x 5.9m`, `7‘5” x 19’6”`],
    "TOTAL INTERNAL AREA": [` 38 SQ M 409 SQ FT`],
    "TOTAL EXTERNAL AREA": [` 4 SQ M 43 SQ FT`],
  },
  E: {
    "LIVING / DINING / KITCHEN": [`5.9m x 7.4m`, `19’4” x 24’3”`],
    BEDROOM: [`1 2.9m x 4.2m`, `9’6” x 13’9”`],
    BALCONY: [`2.4m x 1.9m`, `7’10” x 6’3”`],
    "TOTAL INTERNAL AREA": [`50 SQ M 538 SQ FT`],
    "TOTAL EXTERNAL AREA": [`5 SQ M 53 SQ FT`],
  },
  F: {
    "LIVING / DINING / KITCHEN": [`6.5m x 4.6m`, `21’4” x 15’1”`],
    "BEDROOM 1": [`4.8m x 2.8m`, `15’9” x 9’2”`],
    "BEDROOM 2": [`4.0m x 2.9m`, `13’1” x 9’6”`],
    BALCONY: [`4.0m x 2.2m`, `13’1” x 7’3”`],
    "TOTAL INTERNAL AREA": [`74 SQ M 796 SQ FT`],
    "TOTAL EXTERNAL AREA": [`8 SQ M 86 SQ FT`],
  },
  G: {
    "LIVING / DINING/ KITCHEN": [`5.9m x 3.7m`, `19’ 4” x 12’2”`],
    BEDROOM: [`1 4.3m x 3.1m`, `14’1” x 10’2’`],
    BALCONY: [`2.0m x 2.4m`, `6’7” x 7’10”`],
    "TOTAL INTERNAL AREA": [`50 SQ M 538 SQ FT`],
    "TOTAL EXTERNAL AREA": [`5 SQ M 53 SQ FT`],
  },
  H: {
    "LIVING / DINING": [`5.7m x 4.7m`, `18’8” x 15’5”`],
    KITCHEN: [`2.8m x 2.9m`, `9’2” x 9’6”`],
    "BEDROOM 1": [`2.8m x 4.7m`, `9’2” x 15’5”`],
    "BEDROOM 2": [`3.4m x 3.5m`, `11’2” x 11’6”`],
    "BEDROOM 3": [`3.2m x 3.8m`, `10’6” x 12’6”`],
    BALCONY: [`3.7m x 3.2m`, `12’2” x 10’6”`],
    "TOTAL INTERNAL AREA": [`101 SQ M 1,087 SQ FT`],
    "TOTAL EXTERNAL AREA": [`9 SQ M 96 SQ FT`],
  },
  I: {
    LIVING: [`3.1m x 3.5m`, `10’2” x 11’6”`],
    "DINING / KITCHEN": [`2.8m x 5.0m`, `9’2” x 16’5”`],
    BEDROOM: [`1 3.1m x 4.6m`, `10’2” x 15’1”`],
    BALCONY: [`2.4m x 2.1m`, `7’10” x 6’11”`],
    "TOTAL INTERNAL AREA": [`57 SQ M 613 SQ FT`],
    "TOTAL EXTERNAL AREA": [`5 SQ M 53 SQ FT`],
  },
  J: {
    "LIVING / DINING / KITCHEN": [`4.1m x 4.7m`, `13’5” x 15’5”`],
    BEDROOM: [`1 4.0m x 3.0m`, `13’1” x 9’10”`],
    BALCONY: [`2.4m x 1.9m`, `7’10” x 6’3”`],
    "TOTAL INTERNAL AREA": [`53 SQ M 570 SQ FT`],
    "TOTAL EXTERNAL AREA": [`5 SQ M 53 SQ FT`],
  },
  K: {
    "LIVING / DINING / KITCHEN": [`6.5m x 5.9m`, `21’4” x 19’4”`],
    "BEDROOM 1": [`6.0m x 2.8m`, `19’8” x 9’2”`],
    "BEDROOM 2": [`4.6m x 2.9m`, `15’1” x 9’6”`],
    "BEDROOM 3": [`4.9m x 3.1m`, `16’1” x 10’2”`],
    BALCONY: [`2.0m x 5.1m`, `6’7” x 16’9”`],
    "TOTAL INTERNAL AREA": [`109 SQ M 1,173 SQ FT`],
    "TOTAL EXTERNAL AREA": [`8 SQ M 86 SQ FT`],
  },
}

const FLOORPLAN_NAME = {
  A: "TWO BEDROOM",
  B: "TWO BEDROOM",
  C: "TWO BEDROOM",
  D: "MANHATTAN",
  E: "ONE BEDROOM",
  F: "TWO BEDROOM",
  G: "ONE BEDROOM",
  H: "THREE BEDROOM",
  I: "ONE BEDROOM",
  J: "ONE BEDROOM",
  K: "THREE BEDROOM",
}

const FLOORPLAN_KEYS = {
  A: [
    "01.01",
    "02.01",
    "03.01",
    "04.01",
    "05.01",
    "06.01",
    "07.01",
    "08.01",
    "09.01",
    "10.01",
    "11.01",
    "12.01",
    "13.01",
    "14.01",
    "15.01",
    "16.01",
    "17.01",
    "18.01",
    "19.01",
    "20.01",
    "21.01",
    "22.01",
  ],
  B: ["01.02"],
  C: [
    "02.02",
    "03.02",
    "04.02",
    "05.02",
    "06.02",
    "07.02",
    "08.02",
    "09.02",
    "10.02",
    "11.02",
    "12.02",
    "13.02",
    "14.02",
    "15.02",
    "16.02",
    "17.02",
    "18.02",
    "19.02",
    "20.02",
    "21.02",
    "22.02",
  ],
  D: [
    "01.03",
    "02.03",
    "03.03",
    "04.03",
    "05.03",
    "06.03",
    "07.03",
    "08.03",
    "09.03",
    "10.03",
    "11.03",
    "12.03",
    "13.03",
    "14.03",
  ],
  E: [
    "01.04",
    "02.04",
    "03.04",
    "04.04",
    "05.04",
    "06.04",
    "07.04",
    "08.04",
    "09.04",
    "10.04",
    "11.04",
    "12.04",
    "13.04",
    "14.04",
  ],
  F: [
    "01.05",
    "02.05",
    "03.05",
    "04.05",
    "05.05",
    "06.05",
    "07.05",
    "08.05",
    "09.05",
    "10.05",
    "11.05",
    "12.05",
    "13.05",
    "14.05",
  ],
  G: [
    "01.06",
    "02.06",
    "03.06",
    "04.06",
    "05.06",
    "06.06",
    "07.06",
    "08.06",
    "09.06",
    "10.06",
    "11.06",
    "12.06",
    "13.06",
    "14.06",
  ],
  H: [
    "01.07",
    "02.07",
    "03.07",
    "04.07",
    "05.07",
    "06.07",
    "07.07",
    "08.07",
    "09.07",
    "10.07",
    "11.07",
    "12.07",
    "13.07",
    "14.07",
    "15.06",
    "16.06",
    "17.06",
    "18.06",
    "19.06",
    "20.06",
    "21.06",
    "22.06",
  ],
  I: ["15.03", "16.03", "17.03", "18.03", "19.03", "20.03", "21.03", "22.03"],
  J: ["15.04", "16.04", "17.04", "18.04", "19.04", "20.04", "21.04", "22.04"],
  K: ["15.05", "16.05", "17.05", "18.05", "19.05", "20.05", "21.05", "22.05"],
}
const flattenedMap = {
  "01.01": "A",
  "02.01": "A",
  "03.01": "A",
  "04.01": "A",
  "05.01": "A",
  "06.01": "A",
  "07.01": "A",
  "08.01": "A",
  "09.01": "A",
  "10.01": "A",
  "11.01": "A",
  "12.01": "A",
  "13.01": "A",
  "14.01": "A",
  "15.01": "A",
  "16.01": "A",
  "17.01": "A",
  "18.01": "A",
  "19.01": "A",
  "20.01": "A",
  "21.01": "A",
  "22.01": "A",

  "01.02": "B",

  "02.02": "C",
  "03.02": "C",
  "04.02": "C",
  "05.02": "C",
  "06.02": "C",
  "07.02": "C",
  "08.02": "C",
  "09.02": "C",
  "10.02": "C",
  "11.02": "C",
  "12.02": "C",
  "13.02": "C",
  "14.02": "C",
  "15.02": "C",
  "16.02": "C",
  "17.02": "C",
  "18.02": "C",
  "19.02": "C",
  "20.02": "C",
  "21.02": "C",
  "22.02": "C",

  "01.03": "D",
  "02.03": "D",
  "03.03": "D",
  "04.03": "D",
  "05.03": "D",
  "06.03": "D",
  "07.03": "D",
  "08.03": "D",
  "09.03": "D",
  "10.03": "D",
  "11.03": "D",
  "12.03": "D",
  "13.03": "D",
  "14.03": "D",

  "01.04": "E",
  "02.04": "E",
  "03.04": "E",
  "04.04": "E",
  "05.04": "E",
  "06.04": "E",
  "07.04": "E",
  "08.04": "E",
  "09.04": "E",
  "10.04": "E",
  "11.04": "E",
  "12.04": "E",
  "13.04": "E",
  "14.04": "E",

  "01.05": "F",
  "02.05": "F",
  "03.05": "F",
  "04.05": "F",
  "05.05": "F",
  "06.05": "F",
  "07.05": "F",
  "08.05": "F",
  "09.05": "F",
  "10.05": "F",
  "11.05": "F",
  "12.05": "F",
  "13.05": "F",
  "14.05": "F",

  "01.06": "G",
  "02.06": "G",
  "03.06": "G",
  "04.06": "G",
  "05.06": "G",
  "06.06": "G",
  "07.06": "G",
  "08.06": "G",
  "09.06": "G",
  "10.06": "G",
  "11.06": "G",
  "12.06": "G",
  "13.06": "G",
  "14.06": "G",

  "01.07": "H",
  "02.07": "H",
  "03.07": "H",
  "04.07": "H",
  "05.07": "H",
  "06.07": "H",
  "07.07": "H",
  "08.07": "H",
  "09.07": "H",
  "10.07": "H",
  "11.07": "H",
  "12.07": "H",
  "13.07": "H",
  "14.07": "H",
  "15.06": "H",
  "16.06": "H",
  "17.06": "H",
  "18.06": "H",
  "19.06": "H",
  "20.06": "H",
  "21.06": "H",
  "22.06": "H",

  "15.03": "I",
  "16.03": "I",
  "17.03": "I",
  "18.03": "I",
  "19.03": "I",
  "20.03": "I",
  "21.03": "I",
  "22.03": "I",

  "15.04": "J",
  "16.04": "J",
  "17.04": "J",
  "18.04": "J",
  "19.04": "J",
  "20.04": "J",
  "21.04": "J",
  "22.04": "J",

  "15.05": "K",
  "16.05": "K",
  "17.05": "K",
  "18.05": "K",
  "19.05": "K",
  "20.05": "K",
  "21.05": "K",
  "22.05": "K",
}

let i = 0
function getKey(type) {
  const keys = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"]

  const ID = flattenedMap[type]
  return ID
}

export { flattenedMap, FLOORPLAN_MEASURES, FLOORPLAN_NAME, getKey }
